import React from 'react';
import { Formik } from 'formik';
import type { Participation, ParticipationType } from 'app/types';
import type { UseQueryRefetch } from 'app/types/useQuery.types';
import type { ParticipationFormValues } from '../../EmployeeIncomeParticipations.types';
import { EmployeeIncomeParticipationFormDialogBody } from './components';
import { useParticipationFormValidation, useParticipationFormInitialValues, useParticipationFormSubmit } from './hooks';

type EmployeeIncomeParticipationFormDialogProps = {
  open: boolean;
  closeDialog: () => void;
  connectionId: string | undefined;
  employeeId: string | undefined;
  participation: Participation | null;
  refetchParticipations: UseQueryRefetch;
  availableTypes: ParticipationType[];
};

export const EmployeeIncomeParticipationFormDialog = ({
  open,
  closeDialog,
  connectionId,
  employeeId,
  participation,
  refetchParticipations,
  availableTypes,
}: EmployeeIncomeParticipationFormDialogProps) => {
  const isEdit = participation !== null;

  const { formikInitialValues } = useParticipationFormInitialValues(isEdit, participation, availableTypes);

  const { formikValidationSchema } = useParticipationFormValidation(isEdit, availableTypes);

  const { formikOnSubmit } = useParticipationFormSubmit({
    isEdit,
    connectionId,
    employeeId,
    participation,
    refetchParticipations,
    closeDialog,
  });

  return (
    <Formik<ParticipationFormValues>
      initialValues={formikInitialValues}
      validationSchema={formikValidationSchema}
      onSubmit={formikOnSubmit}
      enableReinitialize
    >
      <EmployeeIncomeParticipationFormDialogBody
        open={open}
        isEdit={isEdit}
        closeDialog={closeDialog}
        availableTypes={availableTypes}
      />
    </Formik>
  );
};
